import { render, staticRenderFns } from "./FinesTable.vue?vue&type=template&id=29da5170"
import script from "./FinesTable.vue?vue&type=script&lang=ts"
export * from "./FinesTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports